"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _spauiUtils = require("@tencent/spaui-utils");

var _info = _interopRequireDefault(require("./info"));

var _chart_props = require("./chart_props");

var _is_equal = _interopRequireDefault(require("./utils/is_equal"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function () { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/**
 * @class
 */
var Chart =
/*#__PURE__*/
function (_Component) {
  _inherits(Chart, _Component);

  function Chart(props) {
    var _this;

    _classCallCheck(this, Chart);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(Chart).call(this, props));

    _this.nullList();

    return _this;
  }

  _createClass(Chart, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.genChart();

      if ((0, _spauiUtils.isFunction)(_spauiUtils.checkCssVersion)) {
        (0, _spauiUtils.checkCssVersion)(_info["default"]);
      }
    }
  }, {
    key: "shouldComponentUpdate",
    value: function shouldComponentUpdate(nextProps, nextState) {
      // 不想等才进行重新渲染，不然会导致Chart一直在变化
      return !((0, _is_equal["default"])(this.props, nextProps) && (0, _is_equal["default"])(this.state, nextState));
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      this.genChart();
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.nullList();
    } // 声明以及一些引用的回收

  }, {
    key: "nullList",
    value: function nullList() {
      this.chartRef = null;
    } // 用于向实例提供内部node的节点引用

  }, {
    key: "getNode",
    value: function getNode() {
      return {
        chart: this.chartRef || null
      };
    } // 获得chart配置

  }, {
    key: "getChart",
    value: function getChart() {
      var _this$props = this.props,
          type = _this$props.type,
          chart = _this$props.chart,
          inverted = _this$props.inverted;
      var defaultConfig = {
        plotBackgroundColor: null,
        plotBorderWidth: null,
        plotShadow: false,
        type: '',
        inverted: false
      }; // 根据不同的类型进行默认的设置

      switch (type) {
        case 'line-time':
          defaultConfig = (0, _spauiUtils.objectAssign)(defaultConfig, {
            zoomType: 'x'
          });
          break;

        case 'polar':
          defaultConfig = (0, _spauiUtils.objectAssign)(defaultConfig, {
            polar: true
          });
          break;

        case 'scatter':
          defaultConfig = (0, _spauiUtils.objectAssign)(defaultConfig, {
            zoomType: 'xy'
          });
          break;

        case 'bubble':
          defaultConfig = (0, _spauiUtils.objectAssign)(defaultConfig, {
            zoomType: 'xy',
            plotBorderWidth: 1
          });
          break;

        default:
          break;
      }

      return (0, _spauiUtils.objectAssign)(defaultConfig, {
        type: type === 'line-time' ? 'line' : type,
        inverted: inverted
      }, chart);
    }
  }, {
    key: "getTooltip",
    value: function getTooltip() {
      var _this$props2 = this.props,
          type = _this$props2.type,
          tooltip = _this$props2.tooltip;
      var defaultConfig = {}; // 默认配置

      switch (type) {
        case 'pie':
          defaultConfig = {
            pointFormat: '{series.name}: <b>{point.percentage:.1f}%</b>'
          };
          break;

        default:
          break;
      }

      return (0, _spauiUtils.objectAssign)(defaultConfig, tooltip);
    } // 获取X轴配置

  }, {
    key: "getXAxis",
    value: function getXAxis() {
      var _this$props3 = this.props,
          _this$props3$xAxisCat = _this$props3.xAxisCategories,
          xAxisCategories = _this$props3$xAxisCat === void 0 ? [] : _this$props3$xAxisCat,
          xAxisTitle = _this$props3.xAxisTitle,
          xAxis = _this$props3.xAxis,
          xAxisReversed = _this$props3.xAxisReversed,
          type = _this$props3.type;
      var result = {};
      var defaultConfig = {
        type: '',
        title: {
          text: xAxisTitle
        },
        reversed: xAxisReversed
      };

      switch (type) {
        case 'line-time':
          defaultConfig = (0, _spauiUtils.objectAssign)(defaultConfig, {
            type: 'datetime'
          });
          break;

        case 'polar':
          defaultConfig = (0, _spauiUtils.objectAssign)(defaultConfig, {
            tickInterval: 45,
            min: 0,
            max: 360,
            labels: {
              formatter: function formatter() {
                return "".concat(this.value, "\xB0");
              }
            }
          });
          break;

        case 'polygon':
          defaultConfig = (0, _spauiUtils.objectAssign)(defaultConfig, {
            gridLineWidth: 1,
            startOnTick: true,
            endOnTick: true,
            showLastLabel: true
          });
          break;

        default:
          break;
      }

      if (xAxisCategories.length > 0) {
        defaultConfig = (0, _spauiUtils.objectAssign)(defaultConfig, {
          categories: xAxisCategories
        });
      }

      if ((0, _spauiUtils.isArray)(xAxis)) {
        result = xAxis;
      } else {
        result = (0, _spauiUtils.objectAssign)(defaultConfig, xAxis);
      }

      return result;
    } // 获取Y轴配置

  }, {
    key: "getYAxis",
    value: function getYAxis() {
      var _this$props4 = this.props,
          _this$props4$yAxisCat = _this$props4.yAxisCategories,
          yAxisCategories = _this$props4$yAxisCat === void 0 ? [] : _this$props4$yAxisCat,
          yAxisTitle = _this$props4.yAxisTitle,
          yAxis = _this$props4.yAxis,
          type = _this$props4.type;
      var result = {};
      var defaultConfig = {
        title: {
          text: yAxisTitle
        }
      };

      switch (type) {
        case 'polar':
          defaultConfig = (0, _spauiUtils.objectAssign)(defaultConfig, {
            min: 0
          });
          break;

        default:
          break;
      }

      if (yAxisCategories.length > 0) {
        defaultConfig = (0, _spauiUtils.objectAssign)(defaultConfig, {
          categories: yAxisCategories
        });
      }

      if ((0, _spauiUtils.isArray)(yAxis)) {
        result = yAxis;
      } else {
        result = (0, _spauiUtils.objectAssign)(defaultConfig, yAxis);
      }

      return result;
    }
  }, {
    key: "getPlotOptions",
    value: function getPlotOptions() {
      var props = this.props || {};
      var result = (0, _spauiUtils.objectAssign)({}, {
        line: {
          dataLabels: {
            enabled: props.dataLabelsEnabled
          },
          enableMouseTracking: true,
          lineWidth: parseInt(props.lineWidth, 10) || 0
        },
        spline: {
          dataLabels: {
            enabled: props.dataLabelsEnabled
          }
        },
        area: {
          dataLabels: {
            enabled: props.dataLabelsEnabled
          },
          fillColor: {
            linearGradient: {
              x1: 0,
              y1: 0,
              x2: 0,
              y2: 1
            },
            stops: [[0, Highcharts.getOptions().colors[0]], [1, Highcharts.Color(Highcharts.getOptions().colors[0]).setOpacity(0).get('rgba')]]
          },
          marker: {
            enabled: false,
            symbol: 'circle',
            radius: 2,
            states: {
              hover: {
                enabled: true
              }
            }
          },
          lineWidth: parseInt(props.lineWidth, 10) || 0,
          states: {
            hover: {
              lineWidth: parseInt(props.lineWidth, 10) || 0
            }
          },
          threshold: null
        },
        pie: {
          allowPointSelect: true,
          cursor: 'pointer',
          dataLabels: {
            enabled: props.dataLabelsEnabled,
            format: '<b>{point.name}</b>: {point.percentage:.1f} %',
            style: {
              color: Highcharts.theme && Highcharts.theme.contrastTextColor || 'black'
            }
          }
        },
        column: {
          pointPadding: 0,
          groupPadding: 0,
          stacking: props.stacking,
          dataLabels: {
            enabled: props.dataLabelsEnabled
          }
        },
        bar: {
          dataLabels: {
            enabled: props.dataLabelsEnabled
          },
          stacking: props.stacking
        },
        scatter: {
          dataLabels: {
            enabled: props.dataLabelsEnabled
          },
          marker: {
            radius: 5,
            states: {
              hover: {
                enabled: true,
                lineColor: 'rgb(100,100,100)'
              }
            }
          },
          states: {
            hover: {
              marker: {
                enabled: false
              }
            }
          }
        },
        series: {
          pointStart: props.pointStart,
          pointInterval: props.pointInterval
        }
      }); // 不同的类型订制下series

      switch (props.type) {
        case 'pyramid':
          result.series = (0, _spauiUtils.objectAssign)(result.series, {
            dataLabels: {
              enabled: true,
              format: '<b>{point.name}</b> ({point.y:,.0f})',
              color: Highcharts.theme && Highcharts.theme.contrastTextColor || 'black',
              softConnector: true
            }
          });
          break;

        case 'bubble':
          result.series = (0, _spauiUtils.objectAssign)(result.series, {
            dataLabels: {
              enabled: true,
              format: '{point.name}'
            }
          });
          break;

        default:
          break;
      } // 如果传了plotOptions可以用来覆盖


      return (0, _spauiUtils.objectAssign)(result, props.plotOptions);
    }
    /**
     * 获取配置
     * @private
     */

  }, {
    key: "getChartData",
    value: function getChartData() {
      var _this$props5 = this.props,
          _this$props5$colors = _this$props5.colors,
          colors = _this$props5$colors === void 0 ? [] : _this$props5$colors,
          type = _this$props5.type,
          pane = _this$props5.pane,
          colorAxis = _this$props5.colorAxis,
          series = _this$props5.series,
          credits = _this$props5.credits,
          title = _this$props5.title,
          subtitle = _this$props5.subtitle,
          legendLayout = _this$props5.legendLayout,
          legendAlign = _this$props5.legendAlign,
          legendVerticalAlign = _this$props5.legendVerticalAlign,
          legendX = _this$props5.legendX,
          legendY = _this$props5.legendY,
          legendWidth = _this$props5.legendWidth,
          legend = _this$props5.legend; // 默认的配置

      var result = {
        chart: this.getChart(),
        // 如果是object的，整个都用外传的
        title: (0, _spauiUtils.isObject)(title) ? (0, _spauiUtils.objectAssign)(title) : {
          text: title
        },
        // 如果是object的，整个都用外传的
        subtitle: (0, _spauiUtils.isObject)(subtitle) ? (0, _spauiUtils.objectAssign)(subtitle) : {
          text: subtitle
        },
        tooltip: this.getTooltip(),
        pane: (0, _spauiUtils.objectAssign)({
          startAngle: 0,
          endAngle: 360
        }, pane),
        xAxis: this.getXAxis(),
        yAxis: this.getYAxis(),
        legend: (0, _spauiUtils.objectAssign)({
          // 提供一些直传的参数
          layout: legendLayout,
          align: legendAlign,
          verticalAlign: legendVerticalAlign,
          x: parseInt(legendX, 10) || 0,
          y: parseInt(legendY, 10) || 0,
          width: parseInt(legendWidth, 10) || 0
        }, legend),
        plotOptions: this.getPlotOptions(),
        series: series,
        credits: (0, _spauiUtils.objectAssign)({
          text: '腾讯广告',
          href: 'http://e.qq.com/',
          enabled: false
        }, credits)
      }; // 如果有设置颜色的话

      if (colors.length > 0) {
        result.colors = colors;
      } // headmap treemap设置下颜色


      if (type === 'headmap' || type === 'treemap') {
        result.colorAxis = (0, _spauiUtils.objectAssign)({
          min: 0,
          minColor: '#FFFFFF',
          maxColor: Highcharts.getOptions().colors[0]
        }, colorAxis);
      }

      return result;
    } // 初始化chart

  }, {
    key: "genChart",
    value: function genChart() {
      var chartCallback = this.props.chartCallback; // 没有组件，啥都没得搞

      if (typeof Highcharts === 'undefined') {
        // eslint-disable-line no-console
        console.error('spaui-chart需要引入Highcharts');
      } else if (this.chartRef) {
        // 如果是希望获取chart的实例，可以通过callback
        this.chart = Highcharts.chart(this.chartRef, this.getChartData(), chartCallback);
        this.Highcharts = Highcharts;
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      return _react["default"].createElement("div", _extends({}, (0, _spauiUtils.globalProps)(this.props, {
        className: 'spaui-chart',
        needTitle: false
      }, Chart), {
        ref: function ref(el) {
          _this2.chartRef = el;
        }
      }));
    }
  }]);

  return Chart;
}(_react.Component); // 组件标记


_defineProperty(Chart, "propTypes", _chart_props.propTypes);

_defineProperty(Chart, "defaultProps", _chart_props.defaultProps);

(0, _spauiUtils.setComponentMark)(Chart, _info["default"]); // 组件上报

(0, _spauiUtils.reportComponentUsage)(_objectSpread({
  scope: 'spaui'
}, _info["default"])); // 用于 focus 样式只在键盘索引时生效，而在鼠标操作时不生效

(0, _spauiUtils.initFocusManager)('spaui-focus-disabled');
var _default = Chart;
exports["default"] = _default;